export default (slug, localePrefix) => {
  const prefix = localePrefix ? `/${localePrefix}` : '';
  const stdSlug = slug.endsWith('/') ? slug : `${slug}/`;
  if (slug === 'home') {
    return `${prefix}/`;
  }
  return `${prefix}/${stdSlug}`;
};
